import autoTable from "jspdf-autotable";
import { PDF_TABLE_STYLE,PDFCOLORSHEME } from "../../../../../../component/constent";
export function drawSummary(doc, summary, grandTotal,) {

  autoTable(doc, {
    startY: 35,
    ...PDF_TABLE_STYLE,
    margin: {
      left: 15,
    },
    theme: "grid",

    head: [["Description", "Amount"]],

    body: [
     
     
      ["DIRECT STORE", format(summary.directStore)],
      ["RETURNED STORE (DRR)", format(summary.returnedStore)],

      ["", ""],
      ["PRIME STORE", format(grandTotal.primeStores)],
      ["ON COST STORE", format(grandTotal.onCostStores)],

     
     
    ],

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_SUMMERY_HEADING,
      cellPadding: 3,
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_SUMMERY_HEADING,
      textColor: PDFCOLORSHEME.FONT_COLOR_SUMMERY_HEADING,
      fontStyle: "bold",
      halign: "center",
    },

    columnStyles: {
      0: {
        halign: "center",
        cellWidth: 52,
      },
      1: {
        halign: "right",
        cellWidth: 32,
      },
    },


  });

  autoTable(doc, {
    startY: 35,
    ...PDF_TABLE_STYLE,
    margin: {
      left: 104,
    },
    theme: "grid",


    

    head: [["Description", "Amount"]],

    body: [
      ["DS8", format(summary.ds8)],
      ["MIN DS8", format(summary.minDs8)],
      ["M-DR", format(summary.mDr)],
      ["MFGD RET.", format(summary.mfgdRet)],
      ["MINUS MFGD RET.", format(summary.minusMfgdRet)],
      
    ],

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_SUMMERY_HEADING,
      cellPadding: 3,
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_SUMMERY_HEADING,
      textColor: PDFCOLORSHEME.FONT_COLOR_SUMMERY_HEADING,
      fontStyle: "bold",
      halign: "center",
    },

    columnStyles: {
      0: {
        halign: "center",
        cellWidth: 52,
      },
      1: {
        halign: "right",
        cellWidth: 32,
      },
    },


  });

  autoTable(doc, {
    startY: 35,
    ...PDF_TABLE_STYLE,
    margin: {
      left: 193,
    },
    theme: "grid",


    

    head: [["Description", "Amount"]],

    body: [
       ["PRIME/DIRECT LABOUR", format(grandTotal.primeLabour)],
      ["ON COST LABOUR", format(grandTotal.onCostLabour)],
      
    ],

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_SUMMERY_HEADING,
      cellPadding: 3,
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_SUMMERY_HEADING,
      textColor: PDFCOLORSHEME.FONT_COLOR_SUMMERY_HEADING,
      fontStyle: "bold",
      halign: "center",
    },

    columnStyles: {
      0: {
        halign: "center",
        cellWidth: 52,
      },
      1: {
        halign: "right",
        cellWidth: 32,
      },
    },


  });

}

function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}